<template>
    <report
        :report="report"
        :versions="versions"
        :loading="loading"
        :refreshing="refreshing"
        @reload="reload"
        @load-version="load_version"
    >
        <div class="lam-graph-container">
            <div class="uk-grid uk-grid-small uk-grid-width-1-2">
                <div>
                    <div class="uk-flex">
                        <div class="uk-margin-right">
                            <ul class="uk-subnav uk-subnav-line">
                                <li class="uk-disabled"><a href="">Staff</a></li>
                                <li :class="{'uk-active': !state.filter}"><a href @click.prevent="set_state_value('filter', '')">All</a></li>
                                <li
                                    v-for="filterable_role in filterable_roles"
                                    :key="filterable_role.id"
                                    :class="{'uk-active': state.filter === filterable_role.id}"
                                >
                                    <a href @click.prevent="set_state_value('filter', filterable_role.id)">
                                        {{ filterable_role.name }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <ul class="uk-subnav uk-subnav-line">
                                <li class="uk-disabled"><a href="">Studio</a></li>
                                <li :class="{'uk-active': !state.studio_id}"><a href @click.prevent="set_state_value('studio_id', '')">All</a></li>
                                <li
                                    v-for="studio in studios"
                                    :key="studio.id"
                                    :class="{'uk-active': state.studio_id === studio.id}"
                                >
                                    <a href @click.prevent="set_state_value('studio_id', studio.id)">{{ studio.name }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="uk-text-right">
                    <div class="uk-button-group lam-graph-filter">
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 6}"
                            @click.prevent="set_scope(6)"
                        >
                            6 weeks
                        </base-button>
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 12}"
                            @click.prevent="set_scope(12)"
                        >
                            3 months
                        </base-button>
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 26}"
                            @click.prevent="set_scope(26)"
                        >
                            6 months
                        </base-button>
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 52}"
                            @click.prevent="set_scope(52)"
                        >
                            1 year
                        </base-button>
                    </div>
                </div>
            </div>
            <div class="uk-grid uk-grid-small uk-margin-bottom lam-graph">
                <div class="uk-width-1-1" style="position: relative;">
                    <billings-graph
                        ref="chart"
                        :chart-data="chart_data"
                        :y-max="ymax"
                        style="height: 600px;"
                    />
                </div>
            </div>
        </div>
    </report>
</template>

<script type="text/javascript">
import is_big_report from "./IsBigReport"
import handles_projects from "./HandlesProjects"

import Report from "./Report.vue"
import BaseButton from "../../ui/BaseButton"
import BillingsGraph from "./BillingsGraph.js"

export default {
    mixins: [is_big_report, handles_projects],
    components: {
        Report,
        BaseButton,
        BillingsGraph
    },
    computed: {
        chart_data () {
            const data = { labels: [], datasets: [] }
            const range_start = this.$moment().startOf("week")
            const range_end = this.$moment(range_start).add(this.state.scope, "weeks")

            if(this.report) {
                const user_datasets = {}
                const report_dataset = this.report.dataset

                Object.keys(report_dataset).forEach(date_string => {
                    const date = this.$moment(date_string)
                    if(date.isSameOrAfter(range_start) && date.isSameOrBefore(range_end)) {
                        data.labels.push(date.format("MMM Do"))

                        Object.keys(report_dataset[date_string]).forEach(initials => {
                            const user = this.raw_user_records.find(user => user.initials === initials)
                            if(user && (!this.state.filter || (this.state.filter === user.role)) && (!this.state.studio_id || (this.state.studio_id === user.studio_id))) {
                                if(!user_datasets[initials]) {
                                    user_datasets[initials] = {
                                        label: user.initials,
                                        backgroundColor: user.hex_color,
                                        borderColor: user.hex_color,
                                        categoryPercentage: 0.9,
                                        barPercentage: 0.8,
                                        fill: false,
                                        data: []
                                    }
                                }

                                const hours = parseFloat(report_dataset[date_string][initials]) || 0
                                user_datasets[initials].data.push(hours * user.billing_rate)
                            }
                        })
                    }
                })
                data.datasets = Object.values(user_datasets)

                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.ymax = 0
                for(let loop = 0; loop < data.labels.length; loop++) {
                    let period_total = 0
                    data.datasets.forEach(dataset => {
                        period_total += parseFloat(dataset.data[loop]) || 0
                    })
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.ymax = Math.max(period_total, this.ymax)
                }
            }

            return data
        }
    },
    data () {
        return {
            report_id: "billings",

            default_state: {
                scope: 6, // nb_weeks
                mode: "absolute",
                filter: "",
                user_id: 0,
                studio_id: 0,
                version_id: 0
            }
        }
    }
}
</script>
